import { Injectable } from "@angular/core";
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { dataset, typeEvent } from "../enum/enum";
import { IcreateModelEvent } from "../models/create-model.interface";
import { ProfileService } from "../services/profile.service";
import { ICretateEvents } from "../models/create-event.interface";
import { EventsService } from "../services/events.service";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { Firestore } from "@angular/fire/firestore";
import { ICreateSalesEvents } from "../models/create-sales-event.interface";
import { ICreateSalesModelEvent } from "../models/create-sales-model.interface";

@Injectable({
    providedIn: 'root'
})
export class Util {

    createEvent !: ICretateEvents;
    createModel!: IcreateModelEvent;
    createSalesModel!: ICreateSalesModelEvent;
    createSalesModelEvent !: ICreateSalesEvents;

    deviceInfo: any;

    constructor(
        private firestore: Firestore,
        private profileService: ProfileService,
        private deviceDetectorService: DeviceDetectorService,
        private analytics: AngularFireAnalytics,
        private eventsService: EventsService
    ) { }

    async eventTagAnalytics(dataCustom: any, screenTitle: string, eventType: string, datasetName: string) {
        this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
        this.createModel = {}
        if (datasetName === dataset.address) {
            this.createModel = {
                locationPage: screenTitle,
                email: this.profileService.email,
                owner: this.profileService.name + " " + this.profileService.first_family_name,
                dob: this.profileService.dob,
                gender: this.profileService.gender,
                phone: this.profileService.phone,
                rfc: this.profileService.billing_rfc,
                regimenFiscal: this.profileService.billing_regimen_fiscal,
                usoCfdi: this.profileService.billing_uso_cfdi,
                exteriorNumber: dataCustom.exterior_number,
                interiorNumber: dataCustom.interior_number_number,
                zip: dataCustom.zip,
                state: dataCustom.state,
                county: dataCustom.county,
                neighborhood: dataCustom.neighborhood,
                addressList: '[' + ']'
            }
        } else if (datasetName === dataset.profile) {
            this.createModel = {
                locationPage: screenTitle,
                owner: this.profileService.name + " " + this.profileService.first_family_name,
                rfc: this.profileService.billing_rfc,
                regimenFiscal: this.profileService.billing_regimen_fiscal,
                usoCfdi: this.profileService.billing_uso_cfdi,
                dob: dataCustom.dob,
                email: dataCustom.email,
                firstFamilyName: dataCustom.first_family_name,
                gender: dataCustom.gender,
                name: dataCustom.name,
                phone: dataCustom.phone,

            }
        } else if (datasetName === dataset.billing) {
            this.createModel = {
                locationPage: screenTitle,
                email: this.profileService.email,
                owner: this.profileService.name + " " + this.profileService.first_family_name,
                dob: this.profileService.dob,
                gender: this.profileService.gender,
                rfc: this.profileService.billing_rfc,
                regimenFiscal: this.profileService.billing_regimen_fiscal,
                billingRazonSocial: dataCustom.razon_social,
                billingRfc: dataCustom.rfc,
                billingRegimenFiscal: dataCustom.regimen_fiscal,
                usoCfdi: dataCustom.uso_cfdi,
                billingEmail: dataCustom.email,
                phone: dataCustom.phone,
                address: dataCustom.address1,
                exteriorNumber: dataCustom.exterior_number,
                interiorNumber: dataCustom.interior_number,
                zip: dataCustom.zip,
                state: dataCustom.state,
                county: dataCustom.county,
                neighborhood: dataCustom.neighborhood,

            }
        } else if (datasetName === dataset.login) {
            this.createModel = {
                locationPage: screenTitle
            }
        } else if (datasetName === dataset.notifications) {
            this.createModel = {
                locationPage: screenTitle
            }
        } else if (datasetName === dataset.business) {
            if (eventType === typeEvent.negocio) {
                this.createModel = {
                    owner: dataCustom.ownerId,
                    businessType: dataCustom.businessTypeId,
                    name: dataCustom.name,
                    description: dataCustom.description,
                    phone: dataCustom.phone,
                    postalCode: dataCustom.postalCode,
                    federalEntity: dataCustom.federalEntity,
                    municipality: dataCustom.municipality,
                    cologne: dataCustom.cologne,
                    street: dataCustom.street,
                    outdoorNumber: dataCustom.outdoorNumber,
                    interiorNumber: dataCustom.interiorNumber,
                    location: dataCustom.location,
                    instagram: dataCustom.instagram,
                    facebook: dataCustom.facebook,
                    webPage: dataCustom.webPage,
                    businessApplication: dataCustom.businessApplication,
                    active: dataCustom.active,
                    color: dataCustom.color
                }
            } else if (eventType === typeEvent.selCategory) {
                this.createModel = {
                    businessType: dataCustom
                }
            }
        }

        this.createEvent = {
            user: this.profileService.email,
            titleScreen: screenTitle,
            event: eventType,
            timeScreen: '',
            tagDate: this.getDate(),
            table: datasetName,
            device: this.deviceInfo.os,
            model: this.createModel,
        }

        this.analytics.logEvent(screenTitle + 'EventsAppClient',
            {
                'firsttimeuser': true,
                'Name': 'AppCliente',
                'email': this.profileService.billing_email,
                'screenTitle': screenTitle,
                'event': eventType,
                'table': datasetName,
                'device': this.deviceInfo.os,
                'owner': this.profileService.name + " " + this.profileService.first_family_name,
                'dob': this.profileService.dob,
                'gender': this.profileService.gender,
                'phone': this.profileService.phone,
                'rfc': this.profileService.billing_rfc,
                'regimen_fiscal': this.profileService.billing_regimen_fiscal,
                'uso_cfdi': this.profileService.billing_uso_cfdi,

            });


        const event = await this.eventsService.sendingEventsApp(this.createEvent);
    }

    async eventSalesTagAnalytics(dataCustom: any, productsList: any, screenTitle: string, eventType: string, datasetName: string) {
        this.deviceInfo = this.deviceDetectorService.getDeviceInfo();

        const firestore = this.firestore;

        let serviceProductList = '';
        if (dataCustom.servicesProducts) {
            serviceProductList = dataCustom.servicesProducts.toString();
        }

        let productsCart: string[] = [];
        for (let listProducts of productsList) {
            if (listProducts.products) {
                for (let product of listProducts.products) {
                    productsCart.push(product.name + ':' + product.quantity);
                }
            }
        }

        let tipoTarjeta = '';
        if (dataCustom.payment.isTarjetaVirtual) {
            tipoTarjeta = 'Pago con tarjeta virtual';
        } else {
            tipoTarjeta = 'Pago con tarjeta bancaria';
        }

        serviceProductList = productsCart.toString();

        this.createSalesModel = {
            ownerId: this.profileService.email,
            bussinesId: productsList[0].name,
            appointmentId: dataCustom.appointmentId,
            customerName: dataCustom.customerName,
            mail: dataCustom.mail,
            total: Number(dataCustom.total),
            subtotal: Number(dataCustom.subtotal),
            taxes: 0,
            discount: 0,
            discountCode: 0,
            salesDateTime: dataCustom.salesDateTime,
            cardId: dataCustom.cardId,
            status: 'active',
            servicesProducts: '[' + serviceProductList + ']',
            payment: tipoTarjeta,
            paymentType: eventType,

        }

        this.createSalesModelEvent = {
            user: this.profileService.email,
            locationPage: screenTitle,
            titleScreen: screenTitle,
            timeScreen: '',
            event: eventType,
            tagDate: this.getDate(),
            table: datasetName,
            device: this.deviceInfo.os,
            model: this.createSalesModel,

        };

        this.analytics.logEvent(screenTitle + 'EventsAppClient',
            {
                'firsttimeuser': true,
                'Name': 'AppCliente',
                'email': this.profileService.billing_email,
                'screenTitle': screenTitle,
                'event': eventType,
                'table': datasetName,
                'device': this.deviceInfo.os,
                'owner': this.profileService.name + " " + this.profileService.first_family_name,
                'total': dataCustom.total,
                'productos': serviceProductList,

            });
        const appointmentAvailability = await this.eventsService.sendingEventsApp(this.createSalesModelEvent);
    }

    getDate() {
        const date = new Date();

        let today = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
        let hourToday = date.toString().substring(16, 21);

        return today + ' ' + hourToday;
    }
}